import React from "react";
import Formulario from "./components/Formulario";
import SurveyForm from "./components/surveyForm";
import SurveyDone from "./components/surveyDone";
import { ToastContainer } from "react-toastify";
// import * as helper from "../src/services/helper";

import {

  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";

//helper.initJoi();

function App() {
  return (
    <React.Fragment>
      <ToastContainer autoClose={1800} />
      <Router>
        <Switch>
          <Route path="/sugerencias" exact component={Formulario} />
          <Route path="/survey/:id/:serviceName" exact component={SurveyForm} />
          <Route path="/done/:id/:serviceName" exact component={SurveyDone} />
          <Redirect from="/" exact to="/sugerencias" />
        </Switch>
      </Router>
    </React.Fragment>
  );
}

export default App;
